"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("./constants");
var NYIcon = 'https://cdn.yc.level.travel/lt-modules-assets/legacy/new-year/new-year.png';
var NYIconMobile = 'https://cdn.yc.level.travel/lt-modules-assets/legacy/new-year/new-year-mobile.png';
var LtLogo = function LtLogo(props) {
  var _props$href = props.href,
    href = _props$href === void 0 ? '/' : _props$href,
    _props$isBlack = props.isBlack,
    isBlack = _props$isBlack === void 0 ? false : _props$isBlack,
    _props$isCompact = props.isCompact,
    isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
    _props$isNewYear = props.isNewYear,
    isNewYear = _props$isNewYear === void 0 ? false : _props$isNewYear,
    _props$className = props.className,
    className = _props$className === void 0 ? isCompact ? 'header-logo-mobile' : 'header-logo' : _props$className;
  return /*#__PURE__*/_react["default"].createElement(StyledLtLogo, {
    href: href,
    isCompact: isCompact,
    isNewYear: isNewYear,
    className: className,
    "aria-label": "Logo"
  }, /*#__PURE__*/_react["default"].createElement(IconWrapper, null, /*#__PURE__*/_react["default"].createElement(Logo, {
    isBlack: isBlack
  })));
};
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LtLogo__IconWrapper",
  componentId: "sc-1p52awg-0"
})(["height:100%;"]);
var Logo = _styledComponents["default"].div.withConfig({
  displayName: "LtLogo__Logo",
  componentId: "sc-1p52awg-1"
})(["width:200px;height:100%;background-image:", " background-repeat:no-repeat;background-position:center;"], function (_ref) {
  var isBlack = _ref.isBlack;
  return "".concat(isBlack ? _constants.CSS_SVG_LOGO_BLACK : _constants.CSS_SVG_LOGO);
});
var StyledLtLogo = _styledComponents["default"].a.withConfig({
  displayName: "LtLogo__StyledLtLogo",
  componentId: "sc-1p52awg-2"
})(["display:inline-block;width:", "px;height:60px;.logo-bg{background:linear-gradient( 90deg,rgba(2,0,36,1) 0%,rgba(9,9,121,1) 35%,rgba(0,212,255,1) 100% );}", " ", ""], function (_ref2) {
  var isCompact = _ref2.isCompact;
  return isCompact ? 60 : 200;
}, function (_ref3) {
  var isCompact = _ref3.isCompact;
  return isCompact && "\n    width: 60px;\n\n    ".concat(IconWrapper, " {\n      width: 30px;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      margin: auto;\n    }\n\n    ").concat(Logo, " {\n      position: absolute;\n      left: -77px;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  ");
}, function (_ref4) {
  var isNewYear = _ref4.isNewYear,
    isCompact = _ref4.isCompact;
  return isNewYear && "\n    background-image: url(".concat(isCompact ? NYIconMobile : NYIcon, ");\n    background-position: ").concat(isCompact ? 'center' : '21px center', ";\n    background-size: 141px 54px;\n    background-repeat: no-repeat;\n  ");
});
var _default = exports["default"] = LtLogo;